<template>
  <div>
    <el-form class="attend-content">
      <el-form-item label="参加的市场顾问" class="flex title-level1">
        <market-staff-dialog
          @change="handleMarketList"
          :originData="market_staff_list"
        >
          <el-button
            class="mwow-button-filled success btn"
            style="margin-left: 60px"
          >
            <span>{{
              market_staff_list.length > 0 ? "再次添加" : "添加"
            }}</span>
            <span> + </span>
          </el-button>
        </market-staff-dialog>
      </el-form-item>
      <div class="content">
        <div
          class="item"
          v-for="(item, index) in market_staff_list"
          :key="item.staff_id"
        >
          <div class="index">{{ index + 1 }}、</div>
          <div class="info">
            <span class="name">{{ item.name }} </span>
            <span class="mobile"> {{ item.mobile }}</span>
          </div>
          <!-- <div class="del" @click="delMarket(item)">✖</div> -->
          <img
            src="https://wowsite.musicwow.com/musicwow_weappui/image/activity/delete.png"
            width="14px"
            height="14px"
            class="del"
            @click="delMarket(item)"
          />
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import marketStaffDialog from "./marketStaffDialog.vue";

export default {
  components: {
    marketStaffDialog,
  },
  props: ["originData"],
  watch: {
    originData: {
      handler() {
        this.market_staff_list = this.originData;
      },
    },
  },
  data() {
    return {
      market_staff_list: [],
    };
  },
  created() {},
  methods: {
    // 删除市场人员
    delMarket(item) {
      this.$confirm(
        `"确定对${item.name}市场顾问在该活动删除吗？"`,
        `"删除${item.name}市场顾问"`,
        {
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          confirmButtonClass: "mwow-button-filled success",
          cancelButtonClass: "mwow-button-filled",
          iconClass: "mwow-icon-error",
        }
      )
        .then(() => {
          let index = this.market_staff_list.indexOf(item);
          this.market_staff_list.splice(index, 1);
          this.$message({
            message: "删除成功",
            type: "success",
          });
        })
        .catch(() => {});
    },
    // 市场数据回传
    handleMarketList(v) {
      this.market_staff_list = v;
      this.$emit("change", this.market_staff_list);
    },
  },
};
</script>
<style lang="scss" scoped>
.title-level1 {
  color: rgba(92, 93, 94, 1);
}
.flex {
  display: flex;
  align-items: center;
}
</style>
